import { postActivityLog } from 'services/generalServices';
import { getTenantDetails } from 'utils/utils';

/**
 * Hook for creating download activity log entries.
 * Mirrors useActivityLogPreview but for download events.
 * Each call fires immediately (no dedup) since downloads are deliberate user actions.
 */
export function useActivityLogDownload() {
  /**
   * @param {object} data - Activity log payload
   * @param {string} data.event_subtype - e.g. 'download_document', 'download_folder', 'download_certificate', 'download_case'
   * @param {string} data.message - Human-readable description
   * @param {string} [data.pk] - File/folder primary key
   * @param {string} [data.sk] - File/folder sort key
   * @param {object} [data.event_items] - Context items (case_id, case_name, is_lead, etc.)
   */
  const addDownloadActivity = (data) => {
    const [tenantId] = getTenantDetails();
    const payload = {
      event_key: 'Download',
      event_type: 'Files',
      event_status: 'success',
      ...data,
      event_items: { tenant_id: tenantId, ...(data.event_items ?? {}) },
    };
    return postActivityLog(payload).catch((err) => {
      console.error('Error posting download activity log:', err);
    });
  };

  return { addDownloadActivity };
}
